import { FormikConsumer, Field } from 'formik';
import classNames from 'classnames';
import FormControl from './FormControl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class DropDown extends Component {
  constructor(props) {
    super(props);

    this.renderOptions = this.renderOptions.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  renderEmpty = (emptyText) => {
    if (emptyText.trim().length) {
      return <option value="">{emptyText}</option>
    }
  };

  renderOptions = () => {
    return (
      this.props.options.map((item, index) =>
        <option key={index} value={item.value}>
          {item.label}
        </option>
      )
    )
  };

  onChange(e) {
    if (this.props.onChangeCallback) {
      this.props.onChangeCallback(this.props.name, e.target.value);
    }
  }

  render() {
    return (
      <FormikConsumer>
        {({ errors, touched }) => (
          <FormControl label={this.props.label}
            hasError={errors[this.props.name] && touched[this.props.name]}
            className={classNames(
              'form-select',
              this.props.className,
            )}
            name={this.props.name}>
            <Field
              as="select"
              name={this.props.name}
              className={classNames('usa-select', 'form-select')}
              id={this.props.name}
              onBlur={this.onChange}>
              {this.renderEmpty(this.props.emptyText)}
              {this.renderOptions()}
            </Field>
          </FormControl>
        )}
      </FormikConsumer>
    );
  }
}

DropDown.defaultProps = {
  className: [],
  options: [],
  label: '',
  value: '',
  defaultValue: '',
  emptyText: '',
  mapped: false
};

DropDown.propTypes = {
  className: PropTypes.array,
  options: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  emptyText: PropTypes.string,
  mapped: PropTypes.bool
};

export default DropDown;
